/**
 * 判断某个原生DOM元素是否不在屏幕可见区内
 * param{*}el原生DOM元素
 */
const isElementNotInViewport = function(el) {
    if(el) {
        let rect = el.getBoundingClientRect();
        return (
            rect.top >= (window.innerHeight || document.documentElement.clientHeight) ||
            rect.bottom <= 0
        );
    }
};

export { isElementNotInViewport};


// WEBPACK FOOTER //
// ./src/action/utils.js